'use strict';
angular.module('oddSurveyQuestionnaireTemplateModule', [
]);
